var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('IconButton',{attrs:{"aria-label":"Share this profile","color":"gray100","filled":""},on:{"click":_vm.handleShare}},[_c('ExportIcon',{attrs:{"title":"share"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }